module.exports = __webpack_public_path__ + "static/img/img_tips.1c1f058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/livebringgoods/img_tips.png
// module id = n8sm
// module chunks = 174